export default __webpack_public_path__ + "static/zkSync_VladyslavBochok_vladbochok1-14bc5a757784ff8c24b2ae43741a9957.jpg";